export default __webpack_public_path__ + "static/mic3-9d9374222696ca5e35b91b285678612c.jpg";